import { render, staticRenderFns } from "./TaskPageChecklist.vue?vue&type=template&id=6a06a7e3&"
import script from "./TaskPageChecklist.vue?vue&type=script&lang=js&"
export * from "./TaskPageChecklist.vue?vue&type=script&lang=js&"
import style0 from "./TaskPageChecklist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports